export default "__VITE_ASSET__B1q2irmz__"